import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    withStyles,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TablePagination,
    TableRow,
    Typography,
    Card,
    CardHeader,
    CardContent
} from "@material-ui/core";
import {
    selectDateFrom,
    selectDateTo,
    //selectReports,
    selectUserNames,
    selectReportTitles,
    selectDataForTable,
    selectJobPackIDs,
    selectSelectedRowIndex
} from "./selectors";
import {
    getTotalUserReports,
    setDateFrom,
    setDateTo,
    getTotalUserNames,
    setUID,
    setWorksheetStatus,
    filterByStatus,
    setReportType,
    getReportTitles,
    getTotalJobPacks,
    setJobID,
    setSelectedRow
} from "./actions";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";

import _ from "lodash";

import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import { viewed } from "vrcore-dashboard/dist/utilities";
import { invoiced } from "vrcore-dashboard/dist/utilities";
import { unviewed } from "vrcore-dashboard/dist/utilities";
const styles = () => ({
    filterUsers: {
        width: "12vw",
        marginBottom: "3vw"
    },
    selecteDate: {
        width: "30vw",
        marginRight: "2vw"
    },
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 5,
        borderRadius: 5
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        padding: 0
    },
    form: {
        width: "400px",
        marginRight: 10,
        marginLeft: 10
    }
});

class UserData extends React.Component {
    constructor(props) {
        super(props);
        props.getTotalUserReports();
        props.getTotalUserNames();
        props.getReportTitles();
        props.getTotalJobPacks();
        this.state = {
            viewed: false,
            unviewed: false,
            invoiced: false,
            selectedUser: [],
            page: 0,
            rowsPerPage: 50,
            selectedReportType: [],
            dateFrom: "",
            dateTo: "",
            selectedJobID: []
        };
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    render() {
        const { rowsPerPage, page } = this.state;
        const worksheets = this.props.reports === false ? [] : this.props.reports;
        const { classes } = this.props;
        const jobIDs = this.props.jobPackIDs === false ? [] : this.props.jobPackIDs;
        return (
            <Card style={{ width: "100%" }}>
                <CardHeader title="Submitted Reports" />
                <CardContent>
                    <div
                        style={{
                            float: "right",
                            width: "50%",
                            marginTop: "18px",
                            display: "flex",
                            flexDirection: "row"
                        }}
                    >
                        <DayPickerInput
                            value={this.state.dateFrom}
                            placeholder="Single Date"
                            format="LL"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={day => {
                                this.props.setDateFrom(day);
                                this.setState({ dateFrom: day });
                            }}
                        />
                        <p>-</p>
                        <DayPickerInput
                            value={this.state.dateTo}
                            placeholder="End Date"
                            format="LL"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={day => {
                                this.props.setDateTo(day);
                                this.setState({ dateTo: day });
                            }}
                        />

                        <Button
                            style={{ marginLeft: "5px", marginTop: "-3px" }}
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                this.props.setDateFrom(false);
                                this.props.setDateTo(false);
                                this.setState({ dateTo: "", dateFrom: "" });
                            }}
                        >
                            Clear Dates
                        </Button>
                    </div>
                    <div
                        style={{
                            width: "50%",
                            display: "flex"
                        }}
                    >
                        <FormControl className={classes.form}>
                            <InputLabel>Users</InputLabel>
                            <Select
                                value={this.state.selectedUser}
                                onChange={event => {
                                    this.setState({
                                        selectedUser: event.target.value
                                    });
                                    this.props.setUID(event.target.value);
                                }}
                            >
                                <MenuItem value={false} key={-1}>
                                    All Users
                                </MenuItem>
                                {this.props.usernames.map(e => {
                                    return (
                                        <MenuItem value={e.uid} key={e.uid}>
                                            {e.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.form} style={{ marginLeft: "2%" }}>
                            <InputLabel>Report Type</InputLabel>
                            <Select
                                value={this.state.selectedReportType}
                                onChange={event => {
                                    this.setState({
                                        selectedReportType: event.target.value
                                    });
                                    this.props.setReportType(event.target.value);
                                }}
                            >
                                <MenuItem value={false} key={-1}>
                                    All Reports
                                </MenuItem>
                                {Object.keys(this.props.reportTitles).map((e, i) => {
                                    return (
                                        <MenuItem value={e} key={i}>
                                            {this.props.reportTitles[e]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.form} style={{ marginLeft: "2%" }}>
                            <InputLabel>Job ID</InputLabel>
                            <Select
                                value={this.state.selectedJobID}
                                onChange={event => {
                                    this.setState({
                                        selectedJobID: event.target.value
                                    });
                                    this.props.setJobID(event.target.value);
                                }}
                            >
                                <MenuItem value={false} key={-2}>
                                    All Reports
                                </MenuItem>
                                <MenuItem value={"standalone"} key={-1}>
                                    Standalone Forms
                                </MenuItem>
                                {Object.keys(jobIDs).map((e, i) => {
                                    return (
                                        <MenuItem value={jobIDs[e].id} key={i}>
                                            {jobIDs[e].id}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.list}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TablePagination
                                        colSpan={12}
                                        ActionsComponent={TablePaginationHelper}
                                        count={worksheets.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[50, 100]}
                                    />
                                </TableRow>
                                <TableRow>
                                    <TableCell padding="none" component="th" scope="row">
                                        <Typography variant="body2">
                                            <b>Timestamp</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography variant="body2">
                                            <b>User Name</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography variant="body2">
                                            <b>Job ID</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography variant="body2">
                                            <b>Report Type</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography
                                            style={{
                                                //width: "6.5vw",
                                                marginRight: "2%",
                                                marginLeft: "2%",
                                                padding: 10
                                            }}
                                            variant="body2"
                                        >
                                            <b>View</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography style={{ marginLeft: "-10px" }} variant="body2">
                                            <b>Viewed</b>

                                            <input
                                                style={{ marginLeft: "12px" }}
                                                checked={this.state.viewed}
                                                type="checkbox"
                                                onChange={() => {
                                                    if (this.state.viewed === true) {
                                                        this.props.filterByStatus(false);
                                                        this.setState({
                                                            viewed: false,
                                                            unviewed: false,
                                                            invoiced: false
                                                        });
                                                    } else {
                                                        this.props.filterByStatus("viewed");
                                                        this.setState({
                                                            viewed: true,
                                                            unviewed: false,
                                                            invoiced: false
                                                        });
                                                    }
                                                }}
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography style={{ marginLeft: "-10px" }} variant="body2">
                                            <b>Unviewed</b>

                                            <input
                                                style={{ marginLeft: "12px" }}
                                                checked={this.state.unviewed}
                                                ref="unviewed"
                                                type="checkbox"
                                                onChange={() => {
                                                    if (this.state.unviewed === true) {
                                                        this.props.filterByStatus(false);
                                                        this.setState({
                                                            viewed: false,
                                                            unviewed: false,
                                                            invoiced: false
                                                        });
                                                    } else {
                                                        this.props.filterByStatus(null);
                                                        this.setState({
                                                            viewed: false,
                                                            unviewed: true,
                                                            invoiced: false
                                                        });
                                                    }
                                                }}
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none">
                                        <Typography style={{ marginLeft: "-10px" }} variant="body2">
                                            <b>Invoiced</b>

                                            <input
                                                style={{ marginLeft: "12px" }}
                                                checked={this.state.invoiced}
                                                type="checkbox"
                                                onChange={() => {
                                                    if (this.state.invoiced === true) {
                                                        this.props.filterByStatus(false);
                                                        this.setState({
                                                            viewed: false,
                                                            unviewed: false,
                                                            invoiced: false
                                                        });
                                                    } else {
                                                        this.props.filterByStatus("invoiced");
                                                        this.setState({
                                                            viewed: false,
                                                            unviewed: false,
                                                            invoiced: true
                                                        });
                                                    }
                                                }}
                                            />
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {worksheets
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((e, i) => {
                                        const timestamp = e.timestamp
                                            .replace(/ /g, "_")
                                            .replace(/:/g, ".");
                                        const reportType = e.report_type.replace(/_/g, "-");
                                        const subjectName = e.subject_name.replace(/_/g, "-");
                                        let name = _.find(this.props.usernames, f => {
                                            if (f.uid === e.uprn) {
                                                return f;
                                            }
                                        });

                                        return (
                                            <TableRow
                                                key={i}
                                                selected={
                                                    this.props.selectedRow === i ? true : false
                                                }
                                                onClick={() => {
                                                    this.props.setSelectedRow(i);
                                                }}
                                            >
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    padding="none"
                                                >
                                                    <Typography variant="body1">
                                                        {e.timestamp}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <Typography variant="body1">
                                                        {name.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <Typography variant="body1">
                                                        {e.subject_name === "reports"
                                                            ? "Standalone Form"
                                                            : e.subject_child}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <Typography variant="body1">
                                                        {this.props.reportTitles[e.report_type]}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <Link
                                                        to={`report-view/${subjectName}/${
                                                            e.subject_child
                                                        }/${reportType}/${timestamp}`}
                                                    >
                                                        <Button
                                                            style={{
                                                                //width: "6.5vw",
                                                                marginRight: 10,
                                                                marginLeft: 10,
                                                                padding: 10
                                                            }}
                                                            color="primary"
                                                            variant="outlined"
                                                        >
                                                            View
                                                        </Button>
                                                    </Link>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <div>
                                                        <img src={viewed} alt="Viewed" />
                                                        <input
                                                            style={{
                                                                marginLeft: "12px"
                                                            }}
                                                            type="checkbox"
                                                            value="viewed"
                                                            checked={
                                                                e.worksheet_status === "viewed"
                                                            }
                                                            onChange={event => {
                                                                e.worksheet_status =
                                                                    event.target.value;
                                                                this.props.setWorksheetStatus(
                                                                    e.uprn,
                                                                    e.timestamp,
                                                                    event.target.value,
                                                                    e.report_type
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <div>
                                                        <img src={unviewed} alt="Unviewed" />
                                                        <input
                                                            style={{
                                                                marginLeft: "12px"
                                                            }}
                                                            type="checkbox"
                                                            value=""
                                                            checked={
                                                                e.worksheet_status === "" ||
                                                                e.worksheet_status === null ||
                                                                e.worksheet_status === undefined
                                                            }
                                                            onChange={event => {
                                                                e.worksheet_status =
                                                                    event.target.value;
                                                                this.props.setWorksheetStatus(
                                                                    e.uprn,
                                                                    e.timestamp,
                                                                    event.target.value,
                                                                    e.report_type
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                                <TableCell padding="none">
                                                    <div>
                                                        <img src={invoiced} alt="Invoiced" />
                                                        <input
                                                            style={{
                                                                marginLeft: "12px"
                                                            }}
                                                            type="checkbox"
                                                            value="invoiced"
                                                            ref={`invoiced` + i + 2}
                                                            checked={
                                                                e.worksheet_status === "invoiced"
                                                            }
                                                            onChange={event => {
                                                                e.worksheet_status =
                                                                    event.target.value;
                                                                this.props.setWorksheetStatus(
                                                                    e.uprn,
                                                                    e.timestamp,
                                                                    event.target.value,
                                                                    e.report_type
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                            {/* <TableFooter>
              <TableRow>
                
              </TableRow>
            </TableFooter> */}
                        </Table>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            //dailyReports: selectReports(store),
            dateFrom: selectDateFrom(store),
            dateTo: selectDateTo(store),
            usernames: selectUserNames(store),
            reportTitles: selectReportTitles(store),
            reports: selectDataForTable(store),
            jobPackIDs: selectJobPackIDs(store),
            selectedRow: selectSelectedRowIndex(store)
        };
    },
    {
        getTotalUserReports,
        setDateFrom,
        setDateTo,
        getTotalUserNames,
        setUID,
        setWorksheetStatus,
        filterByStatus,
        setReportType,
        getReportTitles,
        getTotalJobPacks,
        setJobID,
        setSelectedRow
    }
)(withStyles(styles)(UserData));
